{
  "title": "Guidance",
  "source": "Player's Handbook",
  "levelAndSchool": "Divination cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You touch one willing creature. Once before the spell ends, the target can roll a d4 and add the number rolled to one ability check of its choice. It can roll the die before or after making the ability check. The spell then ends."
  ],
  "spellLists": ["artificer", "cleric", "druid"]
}
